var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("button", { on: { click: _vm.changeOrderBy } }, [
    _vm._v("\n    " + _vm._s(_vm.title) + " "),
    _c("em", { domProps: { innerHTML: _vm._s(_vm.sign) } }),
    _vm._v(" "),
    _vm.property == _vm.$parent.apartments.orderBy.property
      ? _c("i", {
          class: {
            arrdown: _vm.orderBy.type == "asc",
            arrup: _vm.orderBy.type == "desc"
          }
        })
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }